import { PublicClientApplication } from '@azure/msal-browser'

import Config from './features/config.json'
import { getEnviron } from '@services/utils'
const environ = getEnviron()

export const msalConfig = {
    auth: {
        clientId: Config[environ].auth.msal.clientId,
        authority: `${Config[environ].auth.msal.endpoint}${Config[environ].auth.msal.tenantId}`,
        redirectUri: Config[environ].auth.msal.redirectUri
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false
    }
}

export const msalInstance = new PublicClientApplication(msalConfig);

export const loginRequest = {
    scopes: ['User.Read'],
    prompt: 'select_account'
}